import React from "react";
import {
  Box,
  styled,
  Typography,
  Button,
  TextField,
  FormHelperText,
} from "@mui/material";
import BannerImage from "../professionalTournaments/BannerImage";
import {
  ADVERTISEMENT_BANNER_WIDTH,
  ADVERTISEMENT_BANNER_HEIGHT,
} from "../../../utils/advertisementBannerSpec";

const CustomTextarea = styled(TextField)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    color: "black",
    padding: "10px 15px",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
      outline: "none",
    },
  },
  "& .MuiInputBase-input": {
    padding: "0",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const AdvertisementForm = ({ formik, edited }) => {
  return (
    <Box className="page_inner">
      <form onSubmit={formik.handleSubmit}>
        <Box className="create-banner-form professional-tournament-form">
          <Box className="category form-control">
            <Typography className="label">Banner Image</Typography>
            <FormHelperText sx={{ mb: 1 }}>
              Any image is auto-cropped on upload to {ADVERTISEMENT_BANNER_WIDTH}
              ×{ADVERTISEMENT_BANNER_HEIGHT} px so every carousel banner is the
              same size. You do not need to resize the file first.
            </FormHelperText>
            <Box className="Banner_img_preview banner-preview-wide">
              <BannerImage
                formik={formik}
                edited={edited}
                autoFit={{
                  width: ADVERTISEMENT_BANNER_WIDTH,
                  height: ADVERTISEMENT_BANNER_HEIGHT,
                }}
              />
              {formik.touched.image && formik.errors.image ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.image}
                </FormHelperText>
              ) : null}
            </Box>
          </Box>

          <Box className="category form-control">
            <Box className="category_field">
              <Typography className="label">Link URL (optional)</Typography>
              <CustomTextarea
                variant="outlined"
                name="link"
                placeholder="https://example.com (optional)"
                value={formik.values.link}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <FormHelperText>
                Leave blank for a display-only banner with no click action.
              </FormHelperText>
              {formik.touched.link && formik.errors.link ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.link}
                </FormHelperText>
              ) : null}
            </Box>
          </Box>

          <Box className="category form-control">
            <Button className="pt-create" type="submit">
              {edited ? "Update" : "Create"}
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default AdvertisementForm;
